<template>
  <validation-provider v-slot="{ errors }"
                       :name="name"
                       tag="div"
                       class="radio-group"
                       :rules="rules">
    <v-radio-group v-model="internaValue"
                   :error-messages="errors"
                   :disabled="disabled"
                   class="radio-group-options"
                   @change="emitValue">
      <template v-for="(option, index) in options">
        <v-radio :label="option.label"
                 :value="option.value"
                 :key="index"></v-radio>

        <slot :name="`option-${index}`" />
      </template>
    </v-radio-group>

  </validation-provider>
</template>

<script>
import { ValidationProvider } from "vee-validate";

export default {
  components: {
    ValidationProvider,
  },

  props: {
    value: {
      type: String,
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      required: true,
    },
    rules: {
      type: String,
    },
  },

  watch: {
    value: function (val) {
      this.internaValue = val;
    },
  },

  data() {
    return {
      internaValue: undefined,
    };
  },

  methods: {
    emitValue(value) {
      this.$emit("input", value);
    },
  },

  async created() {
    this.internaValue = this.value;
  },

  computed: {},

  mixins: [],
};
</script>

<style lang="scss" scoped>
.radio-group {
  &[center] {
    .radio-group-options {
      justify-content: center;
    }
  }
}
</style>
